//update settings
export const SETTINGS_UPDATE ="SETTINGS_UPDATE"
export const SETTINGS_UPDATE_SUCCESS = "SETTINGS_UPDATE_SUCCESS"
export const SETTINGS_UPDATE_FAIL = "SETTINGS_UPDATE_FAIL"
export const SETTINGS_UPDATE_LOADING ="SETTINGS_UPDATE_LOADING"

//update settings
export const GET_SETTINGS ="GET_SETTINGS"
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS"
export const GET_SETTINGS_FAIL = "GET_SETTINGS_FAIL"
export const GET_SETTINGS_LOADING ="GET_SETTINGS_LOADING"

//update settings
export const GET_NOTIFICATION ="GET_NOTIFICATION"
export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS"
export const GET_NOTIFICATION_FAIL = "GET_NOTIFICATION_FAIL"
export const GET_NOTIFICATION_LOADING ="GET_NOTIFICATION_LOADING"
